import React from "react";
import {
    Checkbox,
    Col,
    ControlLabel,
    FormGroup,
    Radio,
    Row,
} from "react-bootstrap";
import Select from "react-select";
import InputTime from "../../../../InputTime";

const participationTypeOptions = [
    {
        id: "all",
        value: "",
        label: "Всем"
    },
    {
        id: "online",
        value: "online",
        label: "Онлайн зрителям"
    },
    {
        id: "offline",
        value: "offline",
        label: "Офлайн зрителям"
    },
];

export default ({ getProperty, setProperty, saveProperty, saveProperties, isSaving, streamOptions, pagesOptions }) => {
    return <>
        <FormGroup>
            <Row>
                <Col xs={12}>
                    <ControlLabel>Кому доступна активность?</ControlLabel>
                    <div>
                        {participationTypeOptions.map(option => (
                            <Radio
                                key={option.id}
                                value={option.value}
                                name="radioGroup"
                                inline
                                checked={getProperty('participationType') === option.value}
                                onChange={(e) => saveProperty('participationType', e.target.value)}
                                disabled={isSaving}
                            >
                                {option.label}
                            </Radio>
                        ))}
                    </div>
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={12}>
                    <ControlLabel>Где показать сообщение?</ControlLabel>
                    <Checkbox
                        checked={!getProperty('displayPage')?.length && !getProperty('displayStreams')?.length}
                        onChange={(e) => {
                            if (e.target.checked) {
                                saveProperties([{ displayStreams: [] }, { displayPage: [] }])
                            }
                        }}
                        disabled={isSaving}
                    >На всех страницах</Checkbox>
                    <Checkbox
                        checked={getProperty('displayStreams')?.length}
                        onChange={(e) => {
                            if (!e.target.checked) {
                                saveProperty('displayStreams', []);
                            }
                        }}
                        disabled={isSaving || !!getProperty('displayPage')?.length}
                    >В определенных залах</Checkbox>
                    <Select
                        value={streamOptions.filter(({ value }) => getProperty('displayStreams').includes(value))}
                        onChange={(val) => saveProperty('displayStreams', val.map(item => item.value))}
                        placeholder="Выбрать залы"
                        isMulti
                        options={streamOptions}
                        isDisabled={isSaving || !!getProperty('displayPage')?.length}
                    />
                    <Checkbox
                        checked={getProperty('displayPage')?.length}
                        onChange={(e) => {
                            if (!e.target.checked) {
                                saveProperty('displayPage', []);
                            }
                        }}
                        disabled={isSaving || !!getProperty('displayStreams')?.length}
                    >На определенных страницах</Checkbox>
                    <Select
                        value={pagesOptions.filter(({ value }) => getProperty('displayPage').includes(value))}
                        onChange={(val) => saveProperty('displayPage', val.map(item => item.value))}
                        placeholder="Выбрать страницы"
                        isMulti
                        options={pagesOptions}
                        isDisabled={isSaving || !!getProperty('displayStreams')?.length}
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={12}>
                    <Checkbox
                        checked={getProperty('modalTimeout') > 0}
                        onChange={(e) => saveProperty('modalTimeout', e.target.checked ? 1800 : 0)}
                        disabled={isSaving}
                    >Закрыть сообщение автоматически через:</Checkbox>
                    <InputTime
                        value={getProperty('modalTimeout')}
                        onChange={(value) => setProperty('modalTimeout', value)}
                        onBlur={() => saveProperty('modalTimeout', getProperty('modalTimeout'))}
                        disabled={isSaving}
                    />
                </Col>
            </Row>
        </FormGroup>
    </>
}